export default {
    产品荟萃: window.env.VUE_APP_DATA_PRODUCT_ASSEMBLE,
    行业应用: window.env.VUE_APP_DATA_INDUSTRY_APPLICATION,
    相关产品: window.env.VUE_APP_DATA_RELATED_PRODUCTS,
    '工业 4.0': window.env.VUE_APP_DATA_INDUSTRY4_0,
    案例: window.env.VUE_APP_DATA_CASE
}
